import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AuthProviderCard, FormField } from '../components';
export function MicrosoftOAuthSection({ enabled, clientId, clientSecret, tenantId, onToggle, onClientIdChange, onClientSecretChange, onTenantIdChange }) {
    return /*#__PURE__*/ _jsxs(AuthProviderCard, {
        title: "Microsoft OAuth",
        description: "Sign in with Microsoft",
        enabled: enabled,
        onToggle: onToggle,
        children: [
            /*#__PURE__*/ _jsx(FormField, {
                id: "microsoft-client-id",
                label: "Microsoft Client ID (Application ID)",
                value: clientId,
                onChange: onClientIdChange,
                placeholder: "12345678-1234-1234-1234-123456789abc",
                required: true
            }),
            /*#__PURE__*/ _jsx(FormField, {
                id: "microsoft-client-secret",
                label: "Microsoft Client Secret",
                value: clientSecret,
                onChange: onClientSecretChange,
                type: "password",
                placeholder: "Enter to update, leave blank to keep existing",
                helpText: "For security, secrets are not displayed. Enter a new value to update.",
                required: true
            }),
            /*#__PURE__*/ _jsx(FormField, {
                id: "microsoft-tenant-id",
                label: "Microsoft Tenant ID",
                value: tenantId,
                onChange: onTenantIdChange,
                placeholder: "87654321-4321-4321-4321-210987654321",
                helpText: "Also known as Directory ID. Use 'common' for multi-tenant apps.",
                required: true
            })
        ]
    });
}
